import tokens from '../tokens/tokensToTheme.json';

export const BREAKPOINTS = {
  DESKTOP: 'desktop',
  MOBILE: 'base',
  TABLET: 'tablet',
  WIDEDESKTOP: 'wideDesktop',
};

export type Radii = keyof typeof tokens.radii;
export type TypeColors = `${
  | 'neutral'
  | 'purple'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'green'
  | 'turquoise'
  | 'purple'
  | 'blue'}.${'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80' | '90' | '93' | '95' | '100'}`;

export type ColorScheme = 'blue' | 'red' | 'orange' | 'yellow' | 'green' | 'purple' | 'neutral';

export type Shadows = keyof typeof tokens.shadows;

export type TextSizes = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8';

export type TypeSizes = keyof typeof tokens.sizes;

export type DataAttributes = {
  [key: `data-${string}`]: string;
};
